// extracted by mini-css-extract-plugin
export var listStyles = "styles-module--listStyles--XHAyK";
export var featuresBoxWrapper = "styles-module--featuresBoxWrapper--21ITx";
export var featureWrapper = "styles-module--featureWrapper--1jk1e";
export var paragraphChild = "styles-module--paragraphChild--3IERU";
export var highlight = "styles-module--highlight--2sjK9";